import React, { useEffect, useRef, useState } from 'react'
import { MenuProps } from './types'
import menuFn from 'mondrian-vanilla/core/components/Menu/menu'
import { resolveProps } from '../../../utils'
import { Button } from '../../../shared'

export default function Menu(props: MenuProps) {
  const { data, search } = props

  const config = {
    types: [
      {
        title: 'public',
        isDefault: true
      },
      'enterprise',
      'ecommerce',
      'logged'
    ],
    modifiers: [
      {
        title: 'scroll'
      }
    ]
  }

  const[ menuData, setMenuData ] = useState(data)

  const rootElement = useRef()

  useEffect(() => {
    setMenuData(data)
    rootElement.current && menuFn(rootElement.current)
  }, [rootElement, data])

  const [cityModalIsOpen, setCityModalIsOpen] = useState<boolean>(false)
  const [accessibilityModalIsOpen, setAccessibilityModalIsOpen] =
    useState<boolean>(false)

  return (
    <div ref={rootElement}>
      <header className={`mdn-Menu ${resolveProps(props, config, 'Menu')}`}>
        <div className="mdn-Menu-top">
          <div className="mdn-Menu-container">
            <nav className="mdn-Menu-top-content">
              <ul className="mdn-Menu-top-list mdn-Menu-top-list-left">
                {menuData.segments?.map((item, index) => {
                  const ButtonOrLink = item.href ? 'a' : 'button'
                  return (
                    <li
                      key={index}
                      className={`mdn-Menu-top-list-item mdn-Menu-top-list-item-segment ${item.isActive && 'mdn-Menu-top-segment-isActive'
                        }`}
                    >
                      <ButtonOrLink
                        {...item}
                        className="mdn-Menu-top-event mdn-Menu-top-segment-action"
                      >
                        <span className="mdn-Text">{item.title}</span>
                        <span
                          className="mdn-Icon-seta-baixo-preenchida mdn-Icon--sm"
                          aria-hidden="true"
                        ></span>
                      </ButtonOrLink>
                    </li>
                  )
                })}
                {menuData.city && (
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-location">
                    <button
                      className="mdn-Menu-top-event mdn-Modal--handler"
                      title={`Os preços e promoções referem-se a cidade de ${menuData.city.title}. Se desejar, clique para alterar a cidade.`}
                      data-mdn-modal-id="cities-modal"
                      onClick={(e) => setCityModalIsOpen(!cityModalIsOpen)}
                    >
                      <span
                        className="mdn-Icon-localizacao mdn-Icon--md"
                        aria-hidden="true"
                      ></span>
                      <span className="mdn-Text">{menuData.city.title}</span>
                    </button>
                  </li>
                )}
                {menuData.location && (
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-location">
                    <button
                      className="mdn-Menu-top-event"
                      title={`Os preços e promoções referem-se a cidade de São Paulo/SP. Se desejar click para alterar a cidade`}
                      {...menuData.location}
                    >
                      <span
                        className="mdn-Icon-localizacao mdn-Icon--md"
                        aria-hidden="true"
                      ></span>
                      <span className="mdn-Text">{menuData.location.title}</span>
                    </button>
                  </li>
                )}
                {menuData.contract && (
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item--full mdn-Menu-top-list-item-logged">
                    <div className="mdn-Menu-top-action-container">
                      <button
                        className="mdn-Input-action-close-full mdn-Button--secondary mdn-Menu-top-event mdn-Menu-top-action"
                        type="button"
                        title="Fechar busca"
                      >
                        <span
                          className="mdn-Icon-fechar mdn-Icon--xxs"
                          aria-hidden="true"
                        ></span>
                      </button>
                      <button className="mdn-Menu-top-event mdn-Menu-top-action">
                        <span
                          className="mdn-Icon-residencial mdn-Icon--md"
                          aria-hidden="true"
                        ></span>
                        <span className="mdn-Text">{menuData.contract.title}</span>
                        <span
                          className="mdn-Icon-seta-baixo-preenchida mdn-Icon--sm"
                          aria-hidden="true"
                        ></span>
                      </button>
                      <div className="mdn-Menu-top-action-target mdn-Menu-top-action-target--full mdn-Menu-logged-list-container">
                        <ul className="mdn-LinkList">
                          <li className="mdn-LinkList-item">
                            <p className="mdn-Text">
                              {menuData.contract.dataContract.title}
                            </p>
                            <p className="mdn-Text">
                              {menuData.contract.dataContract.address}
                            </p>
                          </li>
                        </ul>
                        <hr className="mdn-Divider mdn-Divider--horizontal mdn-Divider--default" />
                        <div className="mdn-Link mdn-Link--arrow">
                          <a
                            className="mdn-Link-anchor"
                            {...menuData.contract.link}
                          >
                            <span className="mdn-Link-anchor-label">
                              {menuData.contract.link.title}
                            </span>
                            <span className="mdn-Link-anchor-icon mdn-Icon-direita mdn-Icon--sm"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                )}
              </ul>

              <ul className="mdn-Menu-top-list mdn-Menu-top-list-right">
                {search && (
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item--full mdn-Menu-top-list-item-search">
                    <div className="mdn-Menu-top-action-container">
                      <button
                        className="mdn-Input-action-mobile mdn-Menu-top-event mdn-Menu-top-action"
                        type="button"
                        aria-expanded="false"
                        title="Como podemos ajudar?"
                      >
                        <span
                          className="mdn-Icon-busca mdn-Icon--md"
                          aria-hidden="true"
                        ></span>
                      </button>

                      <form
                        className="mdn-Menu-search-container"
                        action="https://www.claro.com.br/busca"
                        method="GET"
                        aria-label="Busque o que deseja e pressione o a tecla Enter para obter o resultado. Como podemos te ajudar?"
                      >
                        <div className="mdn-Input-fieldset">
                          <input
                            placeholder="Busca"
                            name="pesquisa"
                            className="mdn-Input-field mdn-Menu-search-action mdn-Menu-search-action--api"
                            aria-label="Insira um texto para busca"
                            required
                            type="text"
                            data-mdn-type="search"
                          />

                          <button
                            className="mdn-Menu-top-event mdn-Input-search-action mdn-Input-search"
                            title="Busque por algo"
                            type="submit"
                          >
                            <span
                              className="mdn-Icon-busca mdn-Icon--xxs"
                              aria-hidden="true"
                            ></span>
                          </button>
                        </div>

                        <button
                          className="mdn-Input-action-close-full mdn-Menu-top-event mdn-Menu-top-action mdn-Button--secondary"
                          type="button"
                          title="Fechar busca"
                        >
                          <span
                            className="mdn-Icon-fechar mdn-Icon--xxs"
                            aria-hidden="true"
                          ></span>
                        </button>
                      </form>
                    </div>
                  </li>
                )}

                {menuData.icons?.map((icon, index) => {
                  return (
                    <li
                      key={index}
                      className={`mdn-Menu-top-list-item mdn-Menu-top-list-item-accessibility`}
                    >
                      {icon.tag === 'a' ? (
                        <a
                          className="mdn-Menu-top-event"
                          title={icon.title}
                          {...icon}
                        >
                          <span
                            className={`mdn-Icon-${icon.icon} mdn-Icon--sm`}
                            aria-hidden="true"
                          ></span>
                        </a>
                      ) : (
                        <button
                          className="mdn-Menu-top-event"
                          title={icon.title}
                          {...icon}
                        >
                          <span
                            className={`mdn-Icon-${icon.icon} mdn-Icon--sm`}
                            aria-hidden="true"
                          ></span>
                        </button>
                      )}
                    </li>
                  )
                })}

                <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-accessibility">
                  <button
                    className="mdn-Menu-top-event mdn-Modal--handler mdn-isInitialized"
                    title="Modal Zoom texto"
                    data-mdn-modal-id="modal-accessibility-zoom"
                    onClick={(e) =>
                      setAccessibilityModalIsOpen(!accessibilityModalIsOpen)
                    }
                  >
                    <span
                      className="mdn-Icon-diminuir-tamanho mdn-Icon--sm  mdn-Menu-text-icon"
                      aria-hidden="true"
                    ></span>
                    <span
                      className="mdn-Icon-aumentar-tamanho mdn-Icon--sm  mdn-Menu-text-icon"
                      aria-hidden="true"
                    ></span>
                  </button>
                </li>

                {menuData.countries && (
                  <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item--full mdn-Menu-top-list-item-country-list">
                    <div className="mdn-Menu-top-action-container">
                      <button
                        className="mdn-Input-action-close-full mdn-Menu-top-event mdn-Menu-top-action mdn-Button--secondary"
                        type="button"
                        title="Fechar busca"
                      >
                        <span
                          className="mdn-Icon-fechar mdn-Icon--xxs"
                          aria-hidden="true"
                        ></span>
                      </button>

                      {menuData.countries
                        ?.filter((country) => country.isCurrently === true)
                        .map((item, index) => {
                          return (
                            <button
                              key={index}
                              className="mdn-Menu-top-event mdn-Menu-top-action"
                              title={item.title}
                              aria-expanded="false"
                            >
                              <span className="mdn-Menu-list-country-list-flag">
                                <img
                                  className="mdn-Image"
                                  loading="lazy"
                                  src={item.src}
                                  alt={item.alt}
                                />
                              </span>
                              <span
                                className="mdn-Icon-seta-baixo-preenchida mdn-Icon--sm"
                                aria-hidden="true"
                              ></span>
                            </button>
                          )
                        })}

                      <div className="mdn-Menu-top-action-target mdn-Menu-top-action-target--full mdn-Menu-country-list-container">
                        <ul className="mdn-Menu-country-list">
                          {menuData.countries.map((country, index) => {
                            if (index % 2 === 0) {
                              return (
                                <li className="mdn-LinkList-item" key={index}>
                                  <a
                                    className="mdn-Link mdn-LinkList-anchor"
                                    title={country.title}
                                    target="_self"
                                    href={country.href}
                                  >
                                    <div className="mdn-flags-icon">
                                      <img
                                        className="mdn-Image"
                                        aria-hidden="true"
                                        src={country.src}
                                        alt={country.alt}
                                      />
                                    </div>
                                    <p className="mdn-Text">{country.name}</p>
                                  </a>
                                </li>
                              )
                            }
                          })}
                        </ul>
                        <ul className="mdn-Menu-country-list">
                          {menuData.countries.map((country, index) => {
                            if (index % 2 === 1) {
                              return (
                                <li className="mdn-LinkList-item" key={index}>
                                  <a
                                    className="mdn-Link mdn-LinkList-anchor"
                                    title={country.title}
                                    target="_self"
                                    href={country.href}
                                  >
                                    <div className="mdn-flags-icon">
                                      <img
                                        className="mdn-Image"
                                        aria-hidden="true"
                                        src={country.src}
                                        alt={country.alt}
                                      />
                                    </div>
                                    <p className="mdn-Text">{country.name}</p>
                                  </a>
                                </li>
                              )
                            }
                          })}
                        </ul>
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>

        <div className="mdn-Menu-main">
          <div className="mdn-Menu-container">
            <nav className="mdn-Menu-content">
              <div className="mdn-Menu-content-left">
                <button
                  className="mdn-Menu-main-event mdn-Menu-mobile-action"
                  title="Abrir ou fechar subMenu"
                >
                  <i className="mdn-Icon-menu mdn-Icon--md mdn-Menu-mobile-icon mdn-Menu-mobile-icon-menu"></i>
                  <i className="mdn-Icon-fechar mdn-Icon--md mdn-Menu-mobile-icon mdn-Menu-mobile-icon-fechar"></i>
                </button>

                <a
                  className="mdn-Menu-logo-link"
                  href={menuData.logo?.href || '#'}
                  title="Click e confira a página"
                >
                  <img
                    className="mdn-Menu-logo"
                    src={
                      menuData.logo?.src ||
                      'https://mondrian.claro.com.br/brands/horizontal/inverse/claro.svg'
                    }
                    alt={menuData.logo?.alt || 'Logo da Claro'}
                  />
                </a>

                <ul className="mdn-Menu-list mdn-Menu-mobile-action-target">
                  {menuData.menuList.map((menu, index) => (
                    <li key={index} className="mdn-Menu-list-item">
                      <div className="mdn-Menu-list-item-link">
                        <button
                          className="mdn-Menu-main-event mdn-Menu-main-action"
                          aria-expanded="false"
                          type="button"
                        >
                          <span className="mdn-Text">{menu.title}</span>
                          <i className="mdn-Icon-direita mdn-Icon--md"></i>
                        </button>
                      </div>
                      <div className="mdn-Menu-subMenu">
                        <button
                          className="mdn-Menu-subMenu-back"
                          title="Click para Voltar ao nível anterior"
                          type="button"
                        >
                          <span className="mdn-Icon-esquerda mdn-Icon--md"></span>
                          <span className="mdn-Text">
                            Voltar para {menu.title}
                          </span>
                        </button>
                        {React.isValidElement(menu.content) && menu.content}
                        <ul className="mdn-Menu-subMenu-list">
                          {Array.isArray(menu.content) &&
                            menu.content.map((subMenu, index) => (
                              <li
                                key={index}
                                className="mdn-Menu-subMenu-list-item"
                              >
                                <div className="mdn-Menu-list-item-link mdn-Menu-subMenu-title">
                                  <div
                                    className="mdn-Menu-main-event mdn-Menu-main-action"
                                    tabIndex={0}
                                  >
                                    <span
                                      className="mdn-Icon-direita mdn-Icon--md"
                                      aria-hidden="true"
                                    ></span>
                                    <span className="mdn-Text">
                                      {subMenu.title}
                                    </span>
                                  </div>
                                </div>

                                <div className="mdn-Menu-subMenu">
                                  <button
                                    className="mdn-Menu-subMenu-back"
                                    title="Click para Voltar ao nível anterior"
                                    type="button"
                                  >
                                    <span className="mdn-Icon-esquerda mdn-Icon--md"></span>
                                    <span className="mdn-Text">
                                      Voltar para {subMenu.title}
                                    </span>
                                  </button>
                                  <ul className="mdn-Menu-subMenu-list mdn-LinkList">
                                    {subMenu.linkList.map((link, index) => (
                                      <li
                                        key={index}
                                        className="mdn-LinkList-item"
                                      >
                                        <a
                                          className="mdn-LinkList-anchor"
                                          href={link.href}
                                          {...link}
                                        >
                                          {link.title}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mdn-Menu-content-right">
                <ul className="mdn-Menu-list">
                  {menuData.notifications && (
                    <li
                      className={`mdn-Menu-list-item mdn-Menu-list-item-notification ${menuData.notifications.unreadNotification &&
                        'mdn-isNotification'
                        }`}
                    >
                      <div className="mdn-Menu-list-item-link">
                        <button
                          className="mdn-Menu-main-event mdn-Menu-main-action"
                          title="Notificações"
                          aria-expanded="false"
                        >
                          <i className="mdn-Icon-notificacao mdn-Icon--md"></i>
                        </button>
                      </div>
                      <div className="mdn-Menu-subMenu">
                        <div className="mdn-Container">
                          <ul className="mdn-Menu-subMenu-list mdn-Menu-subMenu-notifications">
                            <li className="mdn-Menu-subMenu-list-item">
                              <div className="mdn-Menu-card-notifications">
                                <ul className="mdn-Menu-notifications-list">
                                  {menuData.notifications.list?.map(
                                    (notification, index) => (
                                      <li
                                        key={index}
                                        className="mdn-Menu-notifications-list-item"
                                      >
                                        {notification.content}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )}

                  {menuData.buttonList?.map((button, index) => {
                    const { content, ...rest } = button
                    return (
                      <li
                        key={index}
                        className="mdn-Menu-list-item mdn-Menu-list-item-button"
                      >
                        <div className="mdn-Menu-list-item-link mdn-Menu-list-item-link-button">
                          {button.href ? (
                            <Button
                              tag={'a'}
                              sm
                              {...rest}
                              className="mdn-Menu-main-event mdn-Menu-main-action"
                            >
                              {button.title}
                            </Button>
                          ) : (
                            <Button
                              sm
                              {...rest}
                              className="mdn-Menu-main-event mdn-Menu-main-action"
                            >
                              {button.title}
                            </Button>
                          )}
                        </div>
                        {content}
                      </li>
                    )
                  })}
                  {menuData.logoutButton && (
                    <li className="mdn-Menu-list-item mdn-Menu-list-item-logout">
                      <div className="mdn-Menu-list-item-link">
                        <button className="mdn-Menu-main-event" {...menuData.logoutButton}>
                          <span className="mdn-Icon-sair mdn-Icon--md"></span>
                          <span className="mdn-Text">{menuData.logoutButton.title}</span>
                        </button>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </header>

      <div
        id="modal-accessibility-zoom"
        className={`mdn-Modal mdn-Modal--sm mdn-Menu-modal-accessibility-zoom ${accessibilityModalIsOpen && 'mdn-isOpen'
          }`}
      >
        <div className="mdn-Modal-content">
          <div className="mdn-Modal-body">
            <div className="mdn-Text mdn-Text--body">
              <div>
                Para aumentar ou reduzir a fonte, utilize os atalhos nativos do
                seu navegador:
                <br />
                <ul>
                  <li>
                    <span
                      className="mdn-Icon-verificado mdn-Icon--sm"
                      aria-hidden="true"
                    ></span>
                    No windows&nbsp;<strong>CTRL</strong>
                    +&nbsp;(para aumentar) e&nbsp;<strong>CTRL</strong>{' '}
                    -&nbsp;(para diminuir)
                  </li>
                  <li>
                    <span
                      className="mdn-Icon-verificado mdn-Icon--sm"
                      aria-hidden="true"
                    ></span>
                    No macOS (safari)&nbsp;<strong>CMD</strong>+&nbsp;(para
                    aumentar) e&nbsp;<strong>CMD</strong>-&nbsp;(para diminuir)
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mdn-Modal-footer">
            <div className="mdn-Modal-footer-end">
              <button
                className="mdn-Button mdn-Button--primary  mdn-Button-close"
                onClick={(e) =>
                  setAccessibilityModalIsOpen(!accessibilityModalIsOpen)
                }
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        id="cities-modal"
        className={`mdn-Modal mdn-Menu-modal mdn-cities-modal ${cityModalIsOpen && 'mdn-isOpen'
          }`}
      >
        <div className="mdn-Modal-content">
          <div className="mdn-Modal-header">
            <button
              className="mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondary"
              aria-label="Close modal"
              onClick={(e) => setCityModalIsOpen(!cityModalIsOpen)}
            >
              <i className="mdn-Icon-fechar mdn-Icon--sm"></i>
            </button>
          </div>
          <div className="mdn-Modal-body">{menuData.city?.content || null}</div>
        </div>
      </div>
    </div>
  )
}
